var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirsLoginMove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.9997 -1.08481e-05C6.72884 -1.15711e-05 5.16255e-05 6.72905 5.09024e-05 15.0001C5.01793e-05 23.2709 6.72884 30 14.9997 30C23.2706 30 29.9995 23.2709 29.9995 15.0001C29.9995 6.72905 23.2706 -1.0125e-05 14.9997 -1.08481e-05ZM14.9997 27.9466C7.86107 27.9466 2.05343 22.1388 2.05329 15.0001C2.0533 7.86128 7.86094 2.0535 14.9997 2.05337C22.1384 2.05351 27.946 7.86128 27.946 15.0002C27.946 22.1387 22.1384 27.9466 14.9997 27.9466Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.0139 8.57544C16.6129 8.17462 15.9628 8.17475 15.562 8.57544C15.1609 8.97653 15.1609 9.62649 15.5622 10.0276L19.5074 13.9727L8.08279 13.9738C7.51578 13.9739 7.05623 14.4335 7.05623 15.0007C7.05637 15.5677 7.51592 16.0272 8.08292 16.0272L19.5079 16.0261L15.5617 19.972C15.1608 20.3729 15.1608 21.0232 15.5617 21.424C15.7623 21.6244 16.025 21.7247 16.2878 21.7247C16.5505 21.7247 16.8132 21.6244 17.0138 21.4241L22.7124 15.7256C22.905 15.5331 23.0132 15.2721 23.0132 14.9996C23.013 14.7272 22.9049 14.4663 22.7123 14.2734L17.0139 8.57544Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirsLoginMove);
export default __webpack_public_path__ + "static/media/firsLoginMove.9db9b5b83b5a5f07adb623e1aa63385e.svg";
export { ForwardRef as ReactComponent };